import { Switch, Route, useRouteMatch } from 'react-router-dom';
import LoadComponentWithRetry from '@/app/routes/LoadComponentWithRetry';

const ViewComponent = LoadComponentWithRetry(() => import('./ViewProjectRecordPage'));
const ViewPlanSheetWalkthroughComponent = LoadComponentWithRetry(() => import('@/app/planSheetWalkthrough/ViewPlanSheetWalkthroughPageForProjectRecord'));

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      {/* The plan sheet viewer, under the Drawings list: a sheet, or the walkthroughs. */}
      <Route
        path={[`${path}/:record_uid/document/drawings/:planSheetDocumentUid/walkthroughs`, `${path}/:record_uid/document/drawings/:planSheetUid`]}
        component={ViewPlanSheetWalkthroughComponent}
      />
      <Route path={`${path}/:record_uid`} component={ViewComponent} />
    </Switch>
  );
};

export default Routes;
